const baseOrange = '#F88143';

const colors = {
  orange: baseOrange,
  lightOrange: '#F9945F',
  altOrange: '#E07945',
  darkOrange: '#CB6A37',
  blue: '#2F3F56',

  superLightGray: '#F8F8F9',
  lightGray: 'rgba(244, 244, 244, 0.39)',
  hoverGray: 'rgba(47, 63, 86, 0.08)',
  mediumGray: '#DEDCD5',
  darkGray: '#A6A6A6',
  bgLightGray: '#F4F4F4',

  white: '#ffffff',
  black: '#000000',
  titleGray: '#474747',
};

export default colors;
